<template>
  <div>
    <AIAssistantChatWindow v-model="isOpen" />

    <v-btn
      class="ai-assistant-button"
      :color="isOpen ? 'red' : 'primary'"
      fab
      fixed
      bottom
      right
      small
      elevation="8"
      @click="toggleAssistant"
    >
      <v-icon>{{ isOpen ? 'mdi-close' : 'mdi-robot' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import AIAssistantChatWindow from './AIAssistantChatWindow.vue';

export default {
  name: 'AIAssistantButton',
  components: {
    AIAssistantChatWindow
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleAssistant() {
      this.isOpen = !this.isOpen;
      this.$emit('toggle', this.isOpen);
    }
  }
};
</script>

<style scoped>
.ai-assistant-button {
  margin: 0 16px 16px 0;
  z-index: 1000;
}

.ai-assistant-button:hover {
  transform: scale(1.1);
  transition: transform 0.2s ease-in-out;
}
</style>
